module.exports = __webpack_public_path__ + "static/team-73387e3fa37979f55ebe587b0616a377.svg";